export const screenInfo = {
  ADD: ["Add Additional Patient Pay Schedule Step", "RCAPT001"],
  CHANGE: ["Additional Patient Pay Schedule Step Detail", "RCAPT003"],
  VIEW: ["Additional Patient Pay Schedule Step Detail", "RCAPT003"],
};

// formFields.js

// export const formFields = [
//   { section: "Section 1", name: "apsAddtlPatPaySch", label: "Schedule", fieldLabel: "APS Addtl Pat Pay Sch", type: "text", uppercase: true, options: {}, fieldNature: "Add: Read-only, Change: Read-only, View: Read-only", position: [4, 11] },
//   { section: "Section 1", name: "apsAddtlPatPaySchDesc", label: "Description", fieldLabel: "APS Addtl PatPay Sch Desc", type: "text", uppercase: true, options: {}, fieldNature: "Add: Read-only, Change: Read-only, View: Read-only", position: [5, 22] },
//   { section: "Section 1", name: "aptStepsNbr", label: "Step", fieldLabel: "APT Steps Nbr", type: "number", options: { required: { value: true, message: "REQUIRED" }, min: { value: 1, message: "MIN_1" }, max: { value: 2, message: "MAX_2" } }, fieldNature: "Add: Editable, Change: Read-only, View: Read-only", position: [7, 25] },
//   { section: "Section 1", name: "aptBasis", label: "Basis", fieldLabel: "APT Basis", type: "dropdown", dropdownCondition: "*ALL values", options: { required: { value: true, message: "REQUIRED" } }, fieldNature: "Add: Editable, Change: Editable, View: Read-only", position: [8, 26] },
//   { section: "Section 1", name: "aptMaxValue", label: "Max Value", fieldLabel: "APT Max Value", type: "number", fractionDigits: 3, options: { min: { value: 1, message: "MIN_1" }, max: { value: 11.3, message: "MAX_11.3" } }, fieldNature: "Add: Editable, Change: Editable, View: Read-only", position: [9, 26] },
//   { section: "Additional Patient Pay (Header)", name: "aptAddtlPatPayAmt", label: "$ Amount", fieldLabel: "APT Addtl Pat Pay Amt", type: "number", fractionDigits: 2, options: { min: { value: 1, message: "MIN_1" }, max: { value: 9.2, message: "MAX_9.2" } }, fieldNature: "Add: Editable, Change: Editable, View: Read-only", position: [12, 26] },
//   { section: "Additional Patient Pay (Header)", name: "aptPercentOfCalcBasis", label: "Percent", fieldLabel: "APT Percent of Calc Basis", type: "number", fractionDigits: 2, options: { min: { value: 1, message: "MIN_1" }, max: { value: 5.2, message: "MAX_5.2" } }, fieldNature: "Add: Editable, Change: Editable, View: Read-only", position: [13, 26] },
//   { section: "Additional Patient Pay (Header)", name: "aptCalcBasis", label: "Calc Basis", fieldLabel: "APT Calc Basis", type: "dropdown", dropdownCondition: "*ALL values", options: {}, fieldNature: "Add: Editable, Change: Editable, View: Read-only", position: [14, 26] },
//   { section: "Section 3", name: "macListStandardTxtUsr", label: "MAC List", fieldLabel: "MAC List-Standard Txt.usr", type: "lookup", externalProgram: "RCMCP001I", params: ["carCarrierId", "macListStandardTxtUsr", "wrkCarrierName", "macListName"], options: {}, fieldNature: "Add: Editable, Change: Editable, View: Read-only", position: [16, 26] },
//   { section: "Section 3", name: "macListName", label: "-", fieldLabel: "MAC List Name", type: "text", uppercase: true, options: {}, fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only", position: [16, 37] },
//   { section: "Audit Fields", name: "addDate", label: "Added", fieldLabel: "ADD Date", type: "date", format: "MM/DD/YYYY", options: { highlight: true }, fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only", position: [21, 20] },
//   { section: "Audit Fields", name: "chgDate", label: "Changed", fieldLabel: "CHG Date", type: "date", format: "MM/DD/YYYY", options: { highlight: true }, fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only", position: [21, 40] },
//   { section: "Audit Fields", name: "chgUserName", label: "User", fieldLabel: "CHG User Name", type: "text", uppercase: true, options: { highlight: true }, fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only", position: [21, 57] },
// ];

export const formFields = [
  {
    section: "Schedule",
    name: "apsAddtlPatPaySch",
    label: "Schedule",
    fieldLabel: "APS Addtl Pat Pay Sch",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [4, 11],
  },
  {
    section: "Schedule",
    name: "apsAddtlPatPaySchDesc",
    label: "Description",
    fieldLabel: "APS Addtl PatPay Sch Desc",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 22],
  },
  {
    section: "Schedule",
    name: "aptStepsNbr",
    label: "Step",
    fieldLabel: "APT Steps Nbr",
    type: "number",
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [7, 25],
  },
  {
    section: "Schedule",
    name: "aptBasis",
    label: "Basis",
    fieldLabel: "APT Basis",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 26],
  },
  {
    section: "Schedule",
    name: "aptMaxValue",
    label: "Max Value",
    fieldLabel: "APT Max Value",
    type: "number",
    fractionDigits: 3,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999999.999, message: "MAX_99999999999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 26],
  },
  {
    section: "Additional Patient Pay (Header)",
    name: "aptAddtlPatPayAmt",
    label: "$ Amount",
    fieldLabel: "APT Addtl Pat Pay Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_999999999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 26],
  },
  {
    section: "Additional Patient Pay (Header)",
    name: "aptPercentOfCalcBasis",
    label: "Percent",
    fieldLabel: "APT Percent of Calc Basis",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_99999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 26],
  },
  {
    section: "Additional Patient Pay (Header)",
    name: "aptCalcBasis",
    label: "Calc Basis",
    fieldLabel: "APT Calc Basis",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999999, message: "MAX_9999999999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 26],
  },
  {
    section: "section 3",
    name: "macList",
    label: "MAC List",
    fieldLabel: "MAC List-Standard Txt.usr",
    type: "lookup",
    externalProgram: { default: "RCMCL005" },
    viewType: "legacy",
    params: {
      lookupType: "external",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "macList",
            target: "macList",
            legacy: "pedMacList",
            paramDataKey: "description",
          },
          {
            source: "macListName",
            target: "macListName",
            paramDataKey: "NA",
            legacy: "pedMacListDesc",
          },
          {
            source: "carCarrierId",
            target: "carrier",
            legacy: "pedCarrierId",
            paramDataKey: "searchCriteria",
          },
        ],
      },
      appName: "ACCUMS",
      pageName: "MAC_LIST",
      apiFetch: true,
      apiFieldInputs: [
        { source: "carCarrierId", target: "carCarrierId" },
        { source: "macList", target: "macList" },
        { source: "macListName", target: "macListName" },
      ],
      apiFieldMapping: [
        { source: "carCarrierName", legacy: "wrkCarrierName" },
        { source: "macListName", legacy: "macListName" },
        { source: "carrier", legacy: "pedCarrierId" },
      ],
    },
    options: {
      maxLength: { value: 30, message: "MAXLENGTH_30" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 26],
  },
  {
    section: "section 3",
    name: "macListName",
    label: "",
    fieldLabel: "MAC List Name",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [16, 37],
  },
  {
    section: "Additional Patient Pay (Header)",
    name: "aptCostSource",
    label: "Cost Source",
    fieldLabel: "APT Cost Source",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999999, message: "MAX_9999999999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 26],
  },
  {
    section: "Additional Patient Pay (Header)",
    name: "aptClaimReject",
    label: "Claim Reject",
    fieldLabel: "APT Claim Reject",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 26],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YY",
    options: { highlight: true },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YY",
    options: { highlight: true },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 40],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: {
      maxLength: { value: 10, message: "MAXLENGTH_10" },
      highlight: true,
    },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 57],
  },
];
